export const strings = {
	appTitle: '3D Generative AI/ML Workbench',
	userNotLoggedIn: 'You are not logged in. Please login to continue.',
	login: 'Login',
	logout: 'Logout',
};
